import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'check', 'Check', [["path",{"d":"M5 12l5 5l10 -10","key":"svg-0"}]]);